import { Box } from '@mui/material';
import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import EmptyFeedbacks from './EmptyFeedbacks';
import ErrorFeedbacks from './ErrorFeedbacks';
import { Feedback, FeedbackSkeleton } from './Feedback';

export const FEEDBACK_SKELETON_COUNT = 8;

const useStyles = ({ loading }) => ({
	feedbacksList: {
		overflowX: 'hidden',
		overflowY: loading ? 'hidden' : 'auto',
		paddingRight: '16px',
	},
	feedbackListRelease: {
		paddingRight: '16px',
		display: 'grid',
		gridTemplateColumns: { xs: '1fr', md: '1fr 1fr', lg: '1fr 1fr', xl: '1fr 1fr' },
		padding: '10px 0 15px 0',
		height: 'fit-content',
		gap: '20px',
	},
});

const FeedbacksList = ({ loading, error, feedbacksList, refetch = () => '' }) => {
	const { t } = useTranslation('candidate-feedback');
	const classes = useStyles({ loading });

	const skeletons = useMemo(() => Array.from(Array(FEEDBACK_SKELETON_COUNT)), []);
	const handleRetry = useCallback(() => {
		refetch();
	}, [refetch]);

	const feedbackListCSS = feedbacksList.length !== 0 && classes.feedbackListRelease;

	const renderSkeletons = () =>
		skeletons.map((value, index) => (
			<Box key={index}>
				<FeedbackSkeleton key={index} />
			</Box>
		));

	const renderFeedbacks = () =>
		feedbacksList.map((feedback) => (
			<Feedback key={feedback.feedbackRequestId} feedback={feedback} />
		));

	const renderFeedbacksContent = () => {
		if (loading) {
			return renderSkeletons();
		}
		if (!loading && feedbacksList.length === 0 && !error) {
			return <EmptyFeedbacks />;
		}
		if (!loading && feedbacksList.length > 0 && !error) {
			return renderFeedbacks();
		}
		return null;
	};
	return (
		<Box data-testid="feedbacks-list" width="100%" height="100%" tabIndex="-1">
			<Box sx={feedbackListCSS}>{renderFeedbacksContent()}</Box>

			{!loading && error && (
				<Box sx={{ height: '100%' }}>
					<ErrorFeedbacks onRetry={handleRetry} errorText={t('error_text')} />
				</Box>
			)}
		</Box>
	);
};

export default FeedbacksList;
